<script setup lang="ts">
import { useCdnImages } from '../../../composables/use-cdn-images'

const { cdnImageUrl } = useCdnImages()
</script>

<template>
  <figure>
    <img :src="cdnImageUrl('/images/shared/carwow-logo-wide.svg')"
         width="140"
         height="18">
  </figure>
</template>
